import React from "react";
import { css } from "@emotion/core";
import ClipLoader from "react-spinners/ClipLoader";

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;  
  position: absolute;
  top: 50%;  /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
`;

export default class LoadingIndicator extends React.Component {

    render() {
        return (
            <div className="sweet-loading">
                <ClipLoader
                    css={override} 
                    color="#525f7f"
                />
            </div>
        );
    }
}